<template>
  <layout-default-filters @apply="$_applyQueryString">
    <template #superior>
      <v-form ref="form">
        <core-date-picker-field
          clearable
          v-model="filters.createdFrom"
          label="De"
        />
        <core-date-picker-field
          clearable
          v-model="filters.createdBefore"
          label="Até"
          :rules="createdBeforeRules"
        />
      </v-form>
    </template>
  </layout-default-filters>
</template>

<script>
import { mapMutations } from 'vuex';

import { GENERIC_QUERIES, CONTROLE_ARMAZENAMENTO_QUERIES } from '@/constants/QUERY_FILTERS';
import { getQueryValue, setQueryValue } from '@/services/query-string';
import { CONTROLE_ARMAZENAMENTO_STORAGE } from '@/constants/STORAGE';

import LayoutDefaultFilters from '@/layouts/default/NewFilters.vue';
import CoreDatePickerField from '@/components/core/date-picker-field/Index.vue';

const today = new Date().toISOString().substring(0, 10);

function getSession(key, fallback) {
  return sessionStorage.getItem(key) || fallback;
}

export default {
  name: 'ControleArmazenamentoFilters',

  components: {
    LayoutDefaultFilters,
    CoreDatePickerField,
  },

  data() {
    return {
      filters: {
        createdFrom: getSession(CONTROLE_ARMAZENAMENTO_STORAGE.createFrom, today),
        createdBefore: getSession(CONTROLE_ARMAZENAMENTO_STORAGE.createBefore, today),
      },

      createdBeforeRules: [
        () => {
          const from = new Date(this.filters.createdFrom);
          const to = new Date(this.filters.createdBefore);
          return to >= from || 'Data Final deve ser superior a Data Inicial';
        },
      ],
    };
  },

  methods: {
    ...mapMutations({
      $_setRefresh: 'filter/refresh',
    }),

    $_applyQueryString() {
      setQueryValue(GENERIC_QUERIES.page, 1);
      setQueryValue(CONTROLE_ARMAZENAMENTO_QUERIES.createdFrom, this.filters.createdFrom);
      setQueryValue(CONTROLE_ARMAZENAMENTO_QUERIES.createdBefore, this.filters.createdBefore);
      this.$_setRefresh('S');
    },
  },

  watch: {
    'filters.createdFrom': {
      handler(val) {
        sessionStorage.setItem(CONTROLE_ARMAZENAMENTO_STORAGE.createFrom, val ?? '');
      },
    },
    'filters.createdBefore': {
      handler(val) {
        sessionStorage.setItem(CONTROLE_ARMAZENAMENTO_STORAGE.createBefore, val ?? '');
      },
    },

    filters: {
      deep: true,
      immediate: true,
      handler() {
        this.$nextTick(() => {
          if (this.$refs.form) this.$refs.form.validate();
        });
      },
    },

    $route: {
      deep: true,
      immediate: true,
      handler() {
        this.filters.createdFrom = getQueryValue(
          CONTROLE_ARMAZENAMENTO_QUERIES.createdFrom,
          this.filters.createdFrom,
        );
        this.filters.createdBefore = getQueryValue(
          CONTROLE_ARMAZENAMENTO_QUERIES.createdBefore,
          this.filters.createdBefore,
        );
      },
    },
  },
};
</script>
